// src/hooks/useServiceWorkerUpdate.js
import { useEffect } from 'react';

export const useServiceWorkerUpdate = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      let reloading = false; // Flag to prevent multiple reloads

      // This event fires when the Service Worker controlling the page changes.
      // This is the strongest signal that a new SW has taken over.
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading) return; // Prevent multiple reloads
        reloading = true;
        window.location.reload(); // Force a full reload to get the new app version
      });
    }
  }, []); // Empty dependency array means it runs once on mount
};

export default useServiceWorkerUpdate;
